export default "__VITE_ASSET__DOBrM3Lp__"